jQuery(document).ready(function ($) {

    $('body').on('click', '.teams-overlay', function (e) {
        e.preventDefault();
        let overlay = $(this).attr('data-overlay');
        let userId = $(this).attr('data-user-id');
        let userName = $(this).attr('data-user-name');

        if (!overlay) {
            console.log('product or overlay missing');
        }

        showTeamsOverlay(overlay, userId, userName);
    });

    $('body').on('click', '.edit-name-ajax', function (e) {
        e.preventDefault();

        const overlay = $(this).closest('.overlay');
        const name = overlay.find("#field_name").val();
        const userId = overlay.find("#userId").val();

        if (name) {
            $.ajax({
                type: "POST",
                url: accountingcoach.ajax_url,
                data: {
                    action: "update_user_name",
                    name: name,
                    userId: userId
                },
                success: function (response) {
                    if (response.success) {
                        let table = jQuery('#table2').DataTable();
                        let $td = $("a.teams-overlay[data-user-id='" + userId + "']").closest('td.username');
                        let newHtml = name + ' <a href="#" class="edit-link teams-overlay" data-user-id="' + userId + '" data-user-name="'+ name +'" data-overlay="edit-name">Edit</a>';
                        let cell = table.cell($td);
                        cell.data(newHtml).draw(false);

                        overlay.remove();
                        document.body.style.overflow = "scroll";
                        console.log('success');
                    } else {
                        alert("Error: " + response.data);
                    }
                },
                error: function (xhr, status, error) {
                    console.error("An error occurred:", error);
                },
            });
        } else {
            alert("Please enter a name.");
        }

    });

    $('body').on('click', '.add-member-ajax', function (e) {
        e.preventDefault();

        const overlay = $(this).closest('.overlay');
        const email = overlay.find("#mm_field_email").val();
        const name = overlay.find("#field_name").val();
        // const userId = overlay.find("#userId").val();

        $.ajax({
            type: "POST",
            url: accountingcoach.ajax_url,
            data: {
                action: "add_team_member",
                email: email,
                name: name,
            },
            success: function (response) {
                if (response.success) {
                    console.log('success!');
                    location.reload();
                } else {
                    alert("Error: " + response.data);
                }
            },
            error: function (xhr, status, error) {
                console.error("An error occurred:", error);
                alert('wahai');
            },
        });

    });

    $('body').on('click', '.add-admin-ajax', function (e) {
        e.preventDefault();

        const overlay = $(this).closest('.overlay');
        const email = overlay.find("#mm_field_email").val();
        // const name = overlay.find("#field_name").val();
        // const userId = overlay.find("#userId").val();

        $.ajax({
            type: "POST",
            url: accountingcoach.ajax_url,
            data: {
                action: "add_team_admin",
                email: email,
            },
            success: function (response) {
                if (response.success) {
                    console.log('success!');
                    location.reload();
                } else {
                    alert("Error: " + response.data);
                }
            },
            error: function (xhr, status, error) {
                console.error("An error occurred:", error);
                alert('wahai');
            },
        });

    });



    function showTeamsOverlay(overlay, userId = null, userName = null) {
        let postData = {
            overlay_template: overlay,
        };

        if (userId) {
            postData.userId = userId;
        }

        if (userName) {
            postData.userName = userName;
        }

        $.post(accountingcoach.ajax_url + '?action=ac_get_teams_overlay', postData).then(function (res) {
            $('body').append(res)
            new jBox('Tooltip', {
                attach: '.security-code-icon',
                adjustPosition: true,
                trigger: 'click',
                addClass: 'tooltip-definition',
                zIndex: 9999,
                content: $('.security-code-tooltip'),
                closeButton: true,
                closeOnClick: true,
                position: {
                    x: 'center',
                    y: 'bottom'
                },
                offset: {
                    y: 0
                },
                onOpen: function () {
                    this.content.find('.security-code-tooltip').css({display: 'block'});
                }
            });

            let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            $('body > header .attic').css('padding-right', scrollbarWidth + 20 + 'px');
            document.body.style.overflow = "hidden";


        }).catch(function (e) {
            console.log(e);
        })

    }


    $(document).on('click', '.button.teams-slots-purchase', function (e) {
        e.preventDefault();
        $("#card-errors").html();
        $("#card-errors").css('display', 'none');

        const formValues = $('#payment-form :input');
        var values = {};
        formValues.each(function () {
            if ($(this).attr('type') === 'radio' && !this.checked) {
                return;
            }
            values[this.name] = $(this).val();
        });

        if (!values) {
            $("#card-errors").html('Something went wrong');
            $("#card-errors").css('display', 'block');
            return;
        }
        // if (!values['mm_field_email']) {
        //     $("#card-errors").html('Please fill out all required fields');
        //     $("#card-errors").css('display', 'block');
        //     return;
        // }

        if (values['creditorpaypal'] === 'amazonpay') {
            startAmazonPaySession(values);
            return;
        }

        if (values['creditorpaypal'] === 'credit' || values['creditorpaypal'] === 'applepay') {
            if (!values['mm_field_cc_number'] || !values['mm_field_cc_exp_year'] || !values['mm_field_cc_exp_month'] || !values['mm_field_cc_cvv']) {
                $("#card-errors").html('Please include all card details');
                $("#card-errors").css('display', 'block');
                return;
            }
        }
        $(this).prop('disabled', true);
        $(this).html('<div class="purchase-loader"><div class="purchase-loading"></div></div>');


        var thisCopy = this;

        grecaptcha.execute('6LfvBgAVAAAAADJeWVezAPuuoacbhw4wVIYHfPZh', {action: 'submit'}).then(function (token) {
            $.post(accountingcoach.ajax_url + '?action=ac_team_account_slots_order',
                $('#payment-form').serialize() + '&token=' + token,
            ).then(function (res) {
                if (res.status === 'paypal-redirect') {
                    window.location.replace(res.url);
                } else {
                    // let productData = parseSerializedData($('#payment-form').serialize());
                    console.log($('#payment-form').serialize());
                    // let productName = productNameMap[productData.product_id]
                    // let productPrice = bulkPricingMap[productData.product_id];
                    //TODO: zaraz stuff
                    $('#payment-successful').html('Order complete! Your new users are now available in your team dashboard.')
                    $("#payment-successful").css({
                        'display': 'block',
                        'font-weight': 'bold',
                        'line-height': '150%'
                    });
                    $(thisCopy).hide();
                    window.location.reload();
                }
            }).catch(function (e) {
                $("#card-errors").html(e.responseJSON.message);
                $("#card-errors").css('display', 'block');
                console.log(e);
                $(thisCopy).prop('disabled', false);
                $(thisCopy).html('Submit Order');
            });
        });

    });



});
